import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { AuthService } from '@core/services/auth.service';
import { getB2CError } from '@shared/utils/handle-b2c-error-utils';
import { Observable, of, Subject, timer } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-signup-mobile-phone-b2c',
  templateUrl: './signup-mobile-phone-b2c.component.html',
  styleUrls: ['./signup-mobile-phone-b2c.component.scss'],
})
export class SignUpMobilePhoneB2CComponent implements OnInit, OnDestroy {
  errorMessage$: Observable<string>;
  showStartButton = false;
  private destroying$ = new Subject<void>();
  private started = false;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private msalBroadcastService: MsalBroadcastService,
  ) {}

  ngOnInit(): void {
    this.errorMessage$ = getB2CError(this.msalBroadcastService);

    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      if (params['error']) {
        this.errorMessage$ = of(params['error_description'] || 'Signup failed');
        return;
      }

      this.msalBroadcastService.inProgress$
        .pipe(
          filter((s) => s === InteractionStatus.None),
          take(1),
          takeUntil(this.destroying$),
        )
        .subscribe(() => this.launchSignup());
      timer(1500)
        .pipe(takeUntil(this.destroying$))
        .subscribe(() => {
          if (!this.started) this.showStartButton = true;
        });
    });
  }

  ngOnDestroy(): void {
    this.destroying$.next();
    this.destroying$.complete();
  }

  launchSignup(): void {
    if (this.started) return;
    this.started = true;
    this.authService.signUpPhone();
  }

  resetError(): void {
    this.started = true;
    this.errorMessage$ = of('');
    this.authService.signUpPhone();
  }
}
